/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalInformationProvider = {
    NorthData: 'NORTH_DATA',
    Pappers: 'PAPPERS',
    Inpi: 'INPI'
} as const;
export type LegalInformationProvider = typeof LegalInformationProvider[keyof typeof LegalInformationProvider];


export function instanceOfLegalInformationProvider(value: any): boolean {
    for (const key in LegalInformationProvider) {
        if (Object.prototype.hasOwnProperty.call(LegalInformationProvider, key)) {
            // @ts-ignore
            if (LegalInformationProvider[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalInformationProviderFromJSON(json: any): LegalInformationProvider {
    return LegalInformationProviderFromJSONTyped(json, false);
}

export function LegalInformationProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalInformationProvider {
    return json as LegalInformationProvider;
}

export function LegalInformationProviderToJSON(value?: LegalInformationProvider | null): any {
    return value as any;
}

